<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      d="M3.61111 10.8889H5.16667V7H3.61111V10.8889ZM9.83333 10.8889H11.3889V3.11111H9.83333V10.8889ZM6.72222 10.8889H8.27778V8.55555H6.72222V10.8889ZM6.72222 7H8.27778V5.44444H6.72222V7ZM2.05556 14C1.62778 14 1.2617 13.8478 0.957333 13.5434C0.652963 13.2391 0.500519 12.8727 0.5 12.4444V1.55556C0.5 1.12778 0.652444 0.761704 0.957333 0.457333C1.26222 0.152963 1.6283 0.000518518 2.05556 0H12.9444C13.3722 0 13.7386 0.152444 14.0434 0.457333C14.3483 0.762222 14.5005 1.1283 14.5 1.55556V12.4444C14.5 12.8722 14.3478 13.2386 14.0434 13.5434C13.7391 13.8483 13.3727 14.0005 12.9444 14H2.05556Z"
      fill="#BCEFDB"
    />
  </svg>
</template>

<script>


</script>
